export default __webpack_public_path__ + "static/media/ic_baseline-email.e7958b3e.svg";